import { useSelector } from 'react-redux'

import {
  selectAccountSettings,
  selectAzureAd,
  selectIsAuthenticated,
  selectIsValidatingUser
} from 'redux/selectors/SignedInAccount'

export const useAccountSettings = () => {
  return useSelector(selectAccountSettings)
}

export const useAzureAd = () => {
  return useSelector(selectAzureAd)
}

export const useIsAuthenticated = () => {
  return useSelector(selectIsAuthenticated)
}

export const useIsValidatingUser = () => {
  return useSelector(selectIsValidatingUser)
}
